export const PermissionActions = {
    CanView: 'CanView',
    CanCreate: 'CanCreate',
    CanEdit: 'CanEdit',
    CanDelete: 'CanDelete',
    CanAccess: 'CanAccess',
} as const;

export const PermissionResources = {
    Assets:      'Assets',
    Projects:    'Projects',
    Remediation: 'Remediation',
    Workflow:    'Workflow',
    BulkUpload:  'BulkUpload',
    Users:       'Users',
    Reports:     'Reports',
    Admin:       'Admin',
    Documents:   'Documents',
    Map:         'Map',
    Readiness:   'Readiness',
    CostControl: 'CostControl',
    Planning:    'Planning',
    CostCodes:                          'CostCodes',
    RemediationMonthlyEntries:          'RemediationMonthlyEntries',
    RemediationDoaLimits:               'RemediationDoaLimits',
    RemediationChangeRequestAdmin:      'RemediationChangeRequestAdmin',
    RemediationChangeRequestBulkUpload: 'RemediationChangeRequestBulkUpload',
    RemediationChangeRequest:           'RemediationChangeRequest',
    RemediationMonthlyEntriesActualsEdit: 'RemediationMonthlyEntriesActualsEdit',
    RemediationSnapshots:               'RemediationSnapshots',
} as const;

/** Single source of truth for human-readable screen names — keyed by PermissionResources value. */
export const ResourceLabels: Record<string, string> = {
    [PermissionResources.Assets]:      'Asset Inventory',
    [PermissionResources.Projects]:    'Projects',
    [PermissionResources.Remediation]:  'Remediation',
    [PermissionResources.Documents]:   'Documents',
    [PermissionResources.Workflow]:    'Workflow',
    [PermissionResources.BulkUpload]:  'Bulk Upload',
    [PermissionResources.Users]:       'User Security',
    [PermissionResources.Reports]:     'Reports',
    [PermissionResources.Map]:         'Map',
    [PermissionResources.Readiness]:   'Readiness',
    [PermissionResources.CostControl]: 'Cost Control',
    [PermissionResources.Planning]:    'Planning',
    [PermissionResources.Admin]:       'Admin',
    [PermissionResources.CostCodes]:                          'Cost Codes',
    [PermissionResources.RemediationMonthlyEntries]:          'Monthly Entries',
    [PermissionResources.RemediationDoaLimits]:               'DOA Limits',
    [PermissionResources.RemediationChangeRequestAdmin]:      'Change Request Admin',
    [PermissionResources.RemediationChangeRequestBulkUpload]: 'Change Request Bulk Upload',
    [PermissionResources.RemediationChangeRequest]:           'Change Request',
    [PermissionResources.RemediationMonthlyEntriesActualsEdit]: 'Monthly Entries Actuals Edit',
    [PermissionResources.RemediationSnapshots]:               'Snapshots',
};
